import { render, staticRenderFns } from "./select-mate-color.vue?vue&type=template&id=92d402bc&"
import script from "./select-mate-color.vue?vue&type=script&lang=js&"
export * from "./select-mate-color.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports